// extracted by mini-css-extract-plugin
export default {"wrapper":"mtCHG","layout":"sKyMo","point":"DR8p1","icon":"l79_S","content":"TnAA0"};